export const iconFontAwesomeMapsMotorcycle = (
	<i className="fa-solid fa-motorcycle"></i>
);
